import { render, staticRenderFns } from "./SupportingDetails.vue?vue&type=template&id=02026892&scoped=true&"
import script from "./SupportingDetails.vue?vue&type=script&lang=js&"
export * from "./SupportingDetails.vue?vue&type=script&lang=js&"
import style0 from "./SupportingDetails.vue?vue&type=style&index=0&id=02026892&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02026892",
  null
  
)

export default component.exports